<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSearch" :autoFormCreate="(form) => {
          this.searchForm = form;
        }
        ">
        <a-row :gutter="48">
          <a-col :md="6" :sm="12">
            <a-form-item label="兑换单编号" fieldDecoratorId="order_no">
              <a-input placeholder="兑换单编号" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="!cannotfilterStore">
            <a-form-item label="兑换门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="24">
            <a-form-item label="订单日期" fieldDecoratorId="date_range">
              <a-range-picker />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="用户ID" fieldDecoratorId="uid">
              <a-input placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类" fieldDecoratorId="category_id">
              <a-select placeholder="请选择分类" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="d in major_categories" :key="d.id">{{
                  d.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="零售状态" fieldDecoratorId="is_retail">
              <a-select placeholder="请选择">
                <a-select-option :key="0">全部</a-select-option>
                <a-select-option :key="1">是</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <span class="table-page-search-submitButtons" :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}
              ">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-divider type="vertical" />
              <a-button :loading="downloadLoading" type="primary" icon="export" @click="handleExport">导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" size="small" :columns="columns" :data="loadData">
      <template slot="type" slot-scope="text">
        <span>{{ text | orderType }}</span>
      </template>
      <template slot="price" slot-scope="text, record">
        <span>{{
          record | orderPrice
        }}</span>
      </template>
      <template slot="total_price" slot-scope="text, record">
        <span>{{
          record | orderTotalPrice
        }}</span>
      </template>
      <template slot="status" slot-scope="text, record">
        <span>{{
          text | statusStr
        }}</span>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getOrderList } from "@/api/order";
import { getBranchList } from "@/api/branch";
import { getSupplierList } from "@/api/supplier";
import { encodeJsonToQuery } from "@/utils/util";
import { getCategoryList } from "@/api/category";
import { ACCESS_TOKEN } from "@/store/mutation-types";

export default {
  name: "OrderList",
  components: {
    STable,
  },
  data() {
    return {
      cannotfilterStore: false,
      visible: false,
      Refundvisible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      branches: [],
      suppliers: [],
      major_categories: [], // 分类列表
      form: null,
      mdl: {},
      refunds: {},
      downloadLoading: false,
      downloadAllLoading: false,
      // 查询参数
      searchForm: null,
      queryParam: {
        sort: {
          field: "id",
          reverse: true,
        },
      },
      columns: [
        {
          title: "用户ID",
          dataIndex: "uid",
        },
        {
          title: "兑换单编号",
          dataIndex: "order_no",
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
        },
        {
          title: "所属门店",
          dataIndex: "branch_name",
        },
        {
          title: "sku",
          dataIndex: "sku",
        },
        {
          title: "分类",
          dataIndex: "category_name",
        },
        {
          title: "订单类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        {
          title: "兑换数量",
          dataIndex: "quantity",
        },

        {
          title: "积分/单价/奥莱币",
          dataIndex: "exchange_price",
          scopedSlots: { customRender: "price" },
        },
        // {
        //   title: "兑换规则",
        //   dataIndex: "exchange_price",
        // },
        // {
        //   title: "零售单价",
        //   dataIndex: "retail_price",
        // },
        {
          title: "总积分/总价/总奥莱币",
          dataIndex: "retail_price",
          scopedSlots: { customRender: "total_price" },
        },
        {
          title: "协助店员",
          dataIndex: "admin_user_name",
        },
        {
          title: "订单状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "兑换时间",
          dataIndex: "created",
        },
      ],
      filename: "xxx",
      autoWidth: true,
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getOrderList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
    };
  },
  filters: {
    statusStr(value) {
      const statusStr = [
        "已完成",
        "退款中",
        "已退款"
      ]
      return statusStr[value]
    },
    orderType(value) {
      const orderType = [
        "兑换",
        "零售",
        "奥莱币兑换"
      ]
      return orderType[value]
    },
    orderPrice(value) {
      if (value.type === 0) {
        return value.exchange_price
      } else if (value.type === 1) {
        return value.retail_price
      } else if (value.type === 2) {
        return value.outlets_price
      }
    },
    orderTotalPrice(value) {
      if (value.type === 0) {
        return value.quantity * value.exchange_price
      } else if (value.type === 1) {
        return value.quantity * value.retail_price
      } else if (value.type === 2) {
        return value.quantity * value.outlets_price
      }
    }
  },
  created() {
    this.getBranchList();
    this.getSupplierList();
    this.getCategoryList();
    let userInfo = this.$ls.get("userInfo");
    let canotfilterStoreRole = ["manager", "clerk"];
    this.cannotfilterStore = canotfilterStoreRole.includes(userInfo.role);
  },
  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    getCategoryList: function () {
      getCategoryList({ page_size: 10000 }).then((res) => {
        this.major_categories = res.list;
      });
    },
    getSupplierList() {
      getSupplierList().then((res) => {
        this.suppliers = res.list;
      });
    },
    handleSearch(e) {
      e.preventDefault();
      let filter = {
        order_no: this.searchForm.getFieldValue("order_no"),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        supplier_id: this.searchForm.getFieldValue("supplier_id"),
        uid: this.searchForm.getFieldValue("uid"),
        is_retail: this.searchForm.getFieldValue("is_retail"),
        category_id: this.searchForm.getFieldValue("category_id"),
      };
      const date_range = this.searchForm.getFieldValue("date_range");
      if (date_range) {
        filter["start_date"] = date_range[0].format("YYYY-MM-DD");
        filter["end_date"] = date_range[1].format("YYYY-MM-DD");
      }
      this.queryParam = { ...filter };
      this.$refs.table.refresh();
    },
    handleExport() {
      let filter = {
        order_no: this.searchForm.getFieldValue("order_no"),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        supplier_id: this.searchForm.getFieldValue("supplier_id"),
        uid: this.searchForm.getFieldValue("uid"),
        is_retail: this.searchForm.getFieldValue("is_retail"),
        category_id: this.searchForm.getFieldValue("category_id"),
        token: this.$ls.get(ACCESS_TOKEN),
      };
      const date_range = this.searchForm.getFieldValue("date_range");
      if (date_range) {
        filter["start_date"] = date_range[0].format("YYYY-MM-DD");
        filter["end_date"] = date_range[1].format("YYYY-MM-DD");
      }
      window.open("/api/admin/user/order/excel" + encodeJsonToQuery(filter));
    },
  },
};
</script>
